/**
 * News Entity
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection'
import type { MutationsObject } from '@kp/js-model';;
import dayjs from 'dayjs';

export class News extends BaseModel {
    id: number | null = null;
    titel: string | null = null;
    inhalt: string | null = null;
    kanton: string[] | null = [];
    anzeige_von: string | null = null;
    anzeige_bis: string | null = null;
    ersteller_id: number | null = null;
    statische_anzeige: boolean = false;

    // View fields
    ersteller_name: string | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            ersteller_id: (id) => (Number(id) > 0 ? Number(id) : null),
            statische_anzeige: (val) => !!val,
            created: dayjs,
            modified: dayjs
        };
    }

    getClassName(): string {
        return 'news';
    }
}

export class NewsCollection extends BaseCollection<News> {
    protected modelCls = News;;

    public getModelClassName(): string {
        return 'news';
    }
}
